import { FC } from 'react';
import { StyledDescText, StyledDescTextTV } from '../ProductionOrder.styles';
import styled from 'styled-components';
import { TextType } from '../../../../components/Text';

interface IconDataProps {
  text: string;
  icon: React.ReactNode;
  value?: string;
  fontType?: TextType;
}

const IconDataContainer = styled.div`
  display: flex;
  gap: var(--allie-spacing-md);
  align-items: flex-start;

  svg {
    height: 16px;
    width: 16px;
  }
`;

export const IconData: FC<IconDataProps> = ({ text, icon, value, fontType = 'body3' }) => {
  return (
    <IconDataContainer>
      {icon}
      <StyledDescText color="neutral-60" type={fontType}>
        {text + ':'}
      </StyledDescText>
      <StyledDescText color="neutral-90" type={fontType}>
        {value || '-'}
      </StyledDescText>
    </IconDataContainer>
  );
};

export const IconTVData: FC<IconDataProps> = ({ text, icon, value, fontType = 'h4' }) => {
  return (
    <IconDataContainer style={{ alignItems: 'center' }}>
      {icon}
      <StyledDescTextTV color="neutral-60" weight={400} type={fontType}>
        {text + ':'}
      </StyledDescTextTV>
      <StyledDescTextTV color="neutral-90" weight={400} type={fontType}>
        {value || '-'}
      </StyledDescTextTV>
    </IconDataContainer>
  );
};